import { fetchHelper } from 'utils';
import {
  REQUEST_COMBO_UPSELLS,
  REQUEST_COMBO_UPSELLS_SUCCESS,
  REQUEST_COMBO_UPSELLS_FAILURE,
} from './constants';

export const fetchComboUpsells = (sectionProductId, menuTypeId, serviceId) => (dispatch, getState) => {
  const state = getState();

  const cacheMap = state.getIn(['comboUpsells', 'upsellSectionProducts']);
  const cacheKey = String(sectionProductId);

  // "Fetched" === key exists, even if value is an empty List()
  if (cacheMap && cacheMap.has(cacheKey)) {
    return Promise.resolve(cacheMap.get(cacheKey));
  }

  dispatch({
    type: REQUEST_COMBO_UPSELLS,
    payload: {
      sectionProductId,
      menuTypeId,
      serviceId,
    },
  });

  const success = upsellSectionProducts => {
    dispatch({
      type: REQUEST_COMBO_UPSELLS_SUCCESS,
      payload: {
        sectionProductId,
        upsellSectionProducts,
      },
    });
  };

  const failure = () => {
    dispatch({ type: REQUEST_COMBO_UPSELLS_FAILURE });
  };

  return fetchHelper(
    `/api/section_products/${sectionProductId}/combo-upsells?menuTypeId=${menuTypeId}&serviceId=${serviceId}`,
    'GET',
    null,
    success,
    failure
  );
};
